import { GET_DYNAMIC_FILLLIST, GET_DYNAMIC_REPORT, GET_REPORT_DETAIL, GET_REPORT_LIST } from "../../utils/constants";

const initialState = [];
function reportReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_REPORT_LIST:
      return [...state, payload];
    case GET_REPORT_DETAIL:
      return [...state, payload];
    case GET_DYNAMIC_REPORT:
      return [...state, payload];
    case GET_DYNAMIC_FILLLIST:
      return [...state, payload];
    default:
      return state;
  }
}
export default reportReducer;
